export const DAY_MS = 24 * 60 * 60 * 1000;

/** Short weekday names, indexed the way `Date.getDay` counts. */
export const WEEKDAY_KEYS = [
  'global.weekdaySun',
  'global.weekdayMon',
  'global.weekdayTue',
  'global.weekdayWed',
  'global.weekdayThu',
  'global.weekdayFri',
  'global.weekdaySat',
];

/** Midnight of the day `at` falls on — where "today" starts. */
export const startOfDay = (at: number): number => new Date(at).setHours(0, 0, 0, 0);

/**
 * Names a date from the last week by its weekday, for a list that reads today
 * as a time and anything older as a date.
 * @param {string} value An ISO timestamp.
 * @param {number} now Reference point, injected so the choice can be tested.
 * @returns {null | string} The key, or null for today, anything older or an unparseable value.
 */
export const recentWeekdayKey = (value: string, now: number = Date.now()): null | string => {
  const at = new Date(value).getTime();
  if (Number.isNaN(at)) return null;

  const today = startOfDay(now);
  if (at >= today || at < today - 6 * DAY_MS) return null;

  return WEEKDAY_KEYS[new Date(at).getDay()];
};

export const getDateWithTime = (filter: Date | string, time: string): string => {
  const date = new Date(filter);
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}${time}`;
};

export const getWeek = (date: Date, apply: boolean): string => {
  if (!apply) return date.toLocaleDateString();

  const year = date.getFullYear();
  const jan1 = new Date(year, 0, 1);

  const daysSinceJan1 = (date.getTime() - jan1.getTime()) / 86_400_000;
  const week = Math.ceil((daysSinceJan1 + jan1.getDay() + 1) / 7);

  return `${year}-${String(week).padStart(2, '0')}`;
};
